import { render, staticRenderFns } from "./Deflection.vue?vue&type=template&id=bb5dc516&scoped=true&"
import script from "./Deflection.vue?vue&type=script&lang=js&"
export * from "./Deflection.vue?vue&type=script&lang=js&"
import style0 from "./Deflection.vue?vue&type=style&index=0&id=bb5dc516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5dc516",
  null
  
)

export default component.exports